import {PageLayout} from '@primer/react'
import type {PropsWithChildren} from 'react'
import styles from './SimpleLayout.module.css'

export function SimpleLayout({children}: PropsWithChildren) {
  return (
    <PageLayout columnGap="normal" containerWidth="full" className={styles.simpleLayout}>
      <PageLayout.Content as="div" width="full">
        {children}
      </PageLayout.Content>
    </PageLayout>
  )
}

try{ SimpleLayout.displayName ||= 'SimpleLayout' } catch {}